export default "__VITE_ASSET__189a9e8a__"